import { TRAVELLER_DETAILS_API_CALLED, UPDATE_HYDRA_SEGMENT, UPDATE_LOYALTY_INFO, UPDATE_USER_GOCASH, UPDATE_USER_UUID } from '../../SearchPage/redux/action-types';
import { IHomeStoreState } from './types';

const initialState: IHomeStoreState = {
  offers: [],
  template: {},
  hydraSegments : {},
  uuid: null,
  gocash_bal: null,
  loyalty_info: null,
  travellerDetailsCalled: false
}

export default function HomepageReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_OFFERS': 
      return {
        ...state,
        offers: action.offers
      }
    case 'UPDATE_TEMPLATE':
      return {
        ...state,
        template: action.template
      }

    case UPDATE_HYDRA_SEGMENT:
      return {
        ...state,
        hydraSegments: action.hydraSegments
      }

    case UPDATE_USER_UUID:
      return {
        ...state,
        uuid: action.uuid
      }

    case UPDATE_LOYALTY_INFO:
      return {
        ...state,
        loyalty_info: action.loyalty
      }

    case UPDATE_USER_GOCASH:
      return {
        ...state,
        gocash_bal: action.gocash_bal
      }

    case TRAVELLER_DETAILS_API_CALLED:
      return {
        ...state,
        travellerDetailsCalled: action.travellerDetailsCalled
      }
      
    default:
      return state;
  }
}